import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './AuthContext';
import { AppDataProvider } from './context/AppDataContext'; 
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppDataProvider>  
          <App />
        </AppDataProvider>  
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
